var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-9-art-adherence',{attrs:{"section":9,"page":67}},[_c('p',[_vm._v("\n        It’s good that you’re being honest. Let’s face, it’s tough to commit to something so regularly. Here’s a couple of tidbits that can help you.\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }